


<div class="relative p-0">

  <app-list-view [entityType]="ComponentEntityClass"
                 [contextMenuItems]="contextMenuItems"
                 [showCreateButton]="showCreateButton"
                 [fuseauxParSite]="fuseauxParSite"
                 [canEdit]="canEdit.bind(this)"
                 (entitySelected)="selectSingleItem($event)"
                 (editAction)="editSelectedItem($event)"
                 (deleteAction)="deleteSelectedItem($event)"
                 [ShowRangeDateFilter]="true"
                 [dismissEntity]="dismissEntityState.bind(this)"
                 [onDismissAdded]="dismissEntityState.bind(this)"
                 [onRowDismiss]="handleRowDismiss.bind(this)"
                 [pagination]="{
                      enabled: true,
                      pageLengths: [5, 10, 20, 50, 100, 300],
                      defaultPageLength: 5,
                      searchColumns: null,
                      sortableColumns: null
                    }"
                 [paginatorType]="'button'"
                 [showHeader]="false"
                 (createButtonClick)="openCreateModal()"
                 [listType]="ListType.Stack">
    <!-- Trucker Column -->
    <app-list-table-column key="trucker.fullName" title="{{ 'entities.trucker.propreties.fullName' | translate }}" type="text" [sortable]="true" showLabel="true" align="left"></app-list-table-column>
    <!-- Company Column -->
    <app-list-table-column key="trucker.companyName" title="{{ 'entities.trucker.propreties.companyName' | translate }}" type="text" [sortable]="true" align="center"></app-list-table-column>

    <!-- Check-In Column -->
    <app-list-table-column key="startDate" title="{{ 'entities.truckerActivity.propreties.startDate' | translate }}" type="datetime" [sortable]="true" align="right"></app-list-table-column>

  </app-list-view>

</div>

